module.exports = __webpack_public_path__ + "img/shoshinsha_mark-1-p0.9f3e0f81.svg";